var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.727,
    height: 40,
    viewBox: "0 0 32.727 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M19.364,1A16.365,16.365,0,0,0,3,17.364V30.091a5.447,5.447,0,0,0,5.455,5.455h5.455V21H6.636V17.364a12.727,12.727,0,0,1,25.455,0V21H24.818V35.545h7.273v1.818H19.364V41H30.273a5.447,5.447,0,0,0,5.455-5.455V17.364A16.365,16.365,0,0,0,19.364,1Z",
    transform: "translate(-3 -1)",
    fill: "#fa0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadPhone);
export default __webpack_public_path__ + "static/media/headPhone.f95c9747f0ce10e40a69e00069885561.svg";
export { ForwardRef as ReactComponent };